import { Component, OnInit,ViewChild,AfterViewInit, ViewChildren } from '@angular/core';
import {MatAccordion} from '@angular/material/expansion';
import { NotifierService } from 'angular-notifier';
import { MatDialog} from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import{ ConfirmListadoIniciativasAdminComponent} from 'src/app/components/shared/confirm-listado-iniciativas-admin/confirm-listado-iniciativas-admin.component';




//Interface para los catalogos de estructura
export interface Estructura {
  nombre: string;
  id:number
}

export interface EstructuraSub {
  nombre_subsecretariaSap: string;
  id_subsecretariaSap:number;
  estatus_subsecretariaSap:boolean;
}

export interface EstructuraDirGral {
  nombre_dirgralSap: string;
  id_dirgralSap:number;
  estatus_dirgralSap:boolean;
}

export interface EstructuraDirArea {
  nombre_areaSap: string;
  id_areaSap:number;
  estatus_areaSap:boolean;
}

@Component({
  selector: 'app-estructura',
  templateUrl: './estructura.component.html',
  styleUrls: ['./estructura.component.css']
})
export class EstructuraComponent implements OnInit, AfterViewInit {
  selectedValueSub: number;
  selectedValueDir: number;


  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('TablaSubsecretarias', {static: false}) paginatorSub: MatPaginator;
  @ViewChild('TablaSubSort', {static: false}) sortSub: MatSort;

  
  @ViewChild('TablaDireccionArea', {static: false}) paginatorDA: MatPaginator;
  @ViewChild('TablaDirAreabSort', {static: false}) sortDA: MatSort;
  
  @ViewChild('TablaDireccionGral', {static: false}) paginatorDG: MatPaginator;
  @ViewChild('TablaDirGralbSort', {static: false}) sortDG: MatSort;

  
  @ViewChild('TablaSubDirGral', {static: false}) paginatorDGS: MatPaginator;
  @ViewChild('TablaSubDirGralSort', {static: false}) sortDGS: MatSort;

  
  @ViewChild('TablaDirGralArea', {static: false}) paginatorDGyA: MatPaginator;
  @ViewChild('TablaDirGralAreaSort', {static: false}) sortDyGA: MatSort;

  listaSubsecretaria:EstructuraSub[]=[];
  displayedColumns: string[] = ['Nombre','Acciones'];
  dataSource:any;
  nombreSubse:string;
  loadingGeneral: boolean = false;

  loadingGeneralSub: boolean = false;
  loadingGeneralDirGral: boolean = false;
  loadingGeneralDirArea: boolean = false;




  //Direcciones gral
  listaDirGral:EstructuraDirGral[]=[];
  dataSourceDG:any;
  nombreDirGral:string;

  
  //Direcciones gral sin subsecretaria
  listaDirGralSinSub:EstructuraDirGral[]=[];
  listaDirGralSinSubData:EstructuraDirGral[]=[];
  dataSourceDGS:any;

  //Dirección de area
  listaDirArea:Estructura[]=[];
  dataSourceDA:any;
  nombreDirArea:string;
  longitudDA:number;

  //Subsecretaria-Direccion gral.
  listaSubGral:Estructura[]=[];
  dataSourceSDG:any;

  //Direccion gral-Area
  listaGralArea:Estructura[]=[];
  dataSourceDGA:any;
  selectedValueDirGral: number;
  selectedValueDirArea: number;

  //Direcciones area sin gral.
  listaDirAreaSinGral:EstructuraDirArea[]=[];
  listaDirAreaSinGralData:EstructuraDirArea[]=[];


  
  constructor(private dataService: DataService,
    public dialog:MatDialog,
    private notifier: NotifierService) { 

      this.dataSourceDA=new MatTableDataSource;
      this.dataSource= new MatTableDataSource;
      this.dataSourceDG= new MatTableDataSource;
      this.dataSourceDGS= new MatTableDataSource;
      this.dataSourceDGA= new MatTableDataSource;
    }

  ngOnInit(): void { 
    this.cargarSubsecretarias();
    this.cargarDireccionArea();
    this.cargarDireccionGral();
    this.cargarDireccionGralSinSub();
    this.cargarDireccionAreaSinGral();
  }

  ngAfterViewInit() {
  }

  onChangeSubse(idSubsecretaria: number) 
  {
    this.selectedValueSub = idSubsecretaria;
    this.dataService.getDirGralBySubsecretaria(idSubsecretaria).subscribe(
      data => {
        if (data['data']) {
          this.listaDirGralSinSubData = data['data'];
          this.dataSourceDGS.data=this.listaDirGralSinSubData;
          this.dataSourceDGS.paginator=this.paginatorDGS;
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  //Método para agregar subsecretaria con dir gral.
  AgregarSubDirGral(id_subsecretaria:number, id_dirgral:number)
  {
    this.loadingGeneral=true;
    this.dataService.insertUpdateSubsDirGral(id_dirgral,id_subsecretaria).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Se agrego correctamente.'
          );
          this.onChangeSubse(id_subsecretaria);
          this.loadingGeneral=false;
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
          this.loadingGeneral=false;
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar agregar la subsecretaria. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }

  //Eliminar subsecretaria con dir. gral
  eliminarSubDirGral(idDirGral:number)
  {
    
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:idDirGral,opcion:21},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneral=true;
       this.dataService.deleteSubsDirGral(idDirGral).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.onChangeSubse(this.selectedValueSub);
             this.loadingGeneral=false;

           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar la subsecretaria. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 

  }

  //Método para modificar la relacion subsecretaria-dir.gral
  updateSubDirGral(id_dirgral:number)
  {
    let id_subsecretaria=this.selectedValueSub;
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id_dirgral,opcion:23,idSubsecretaria:this.selectedValueSub,titulo:"Editar Subsecretaria-Dirección Gral.",etiqueta:"Dirección general"},disableClose:true, width: '600px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
       this.loadingGeneral=true;
       this.dataService.insertUpdateSubsDirGral(id_dirgral,result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.onChangeSubse(this.selectedValueSub);
             this.loadingGeneral=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
             this.loadingGeneral=false;
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar la dirección gral. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });


  }



  
  //Método para cargar la direccion gral. sin subsecretarias
  cargarDireccionAreaSinGral()
  {
    this.dataService.getListDireccionAreaSinGral().subscribe(
      data => {
        this.listaDirAreaSinGral = data['data'];
        //this.dataSourceDGS.data=this.listaDirGralSinSub;
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para cargar las direcciones de area
  onChangeDirGral(idDirGral: number) 
  {
    this.selectedValueDirGral = idDirGral;
    this.dataService.getDirAreaByGral(idDirGral).subscribe(
      data => {
        if (data['data']) {
          this.listaDirAreaSinGralData = data['data'];
          this.dataSourceDGA.data=this.listaDirAreaSinGralData;
          this.dataSourceDGA.paginator=this.paginatorDGyA;
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  //Método para agregar subsecretaria con dir gral.
  AgregarDirGralArea(id_dirGral:number, id_dirArea:number)
  {
    this.loadingGeneral=true;
    this.dataService.insertUpdateDirGralArea(id_dirGral,id_dirArea).subscribe(
      data => {
        if (data['objData']) 
        {
          this.notifier.notify(
            'success',
            'Se agrego correctamente.'
          );
          this.onChangeDirGral(id_dirGral);
          this.loadingGeneral=false;
        }
        else{
          this.notifier.notify('error',data['errorMessage']);
          this.loadingGeneral=false;
        }
      },
      error => {
        console.error(error);
        this.notifier.notify(
          'error',
          'Ha ocurrido un error al intentar agregar la dirección de área. Verifique su conexión de red o contacte al administrador.'
        );
      }
    );
  }


  
  //Eliminar subsecretaria con dir. gral
  eliminarDirGralArea(idDirArea:number)
  {
    
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:idDirArea,opcion:21},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneral=true;
       this.dataService.deleteDirGralArea(idDirArea).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.onChangeDirGral(this.selectedValueDirGral);
             this.loadingGeneral=false;

           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar la subsecretaria. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 

  }

  //Método para modificar la relacion subsecretaria-dir.gral
  updateDirGralArea(id_dirArea:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id_dirArea,opcion:24,idDirGral:this.selectedValueDirGral,titulo:"Editar Dirección General-Dirección de área",etiqueta:"Dirección general"},disableClose:true, width: '600px'});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
       this.loadingGeneral=true;
       this.dataService.insertUpdateDirGralArea(result, id_dirArea).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.onChangeDirGral(this.selectedValueDirGral);
             this.loadingGeneral=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
             this.loadingGeneral=false;
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar la dirección gral. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });


  }
  
  //Filtro para las subsecretarias
  applyFilterSubsecretaria(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  //Método para cargar las subsecretarias
  cargarSubsecretarias()
  {
    
    this.dataService.getListSubsecretarias().subscribe(
      data => {
        this.listaSubsecretaria = data['data'];
        this.dataSource.data = this.listaSubsecretaria;
        this.dataSource.paginator=this.paginatorSub;
        
      },
      error => {
        console.error(error);       
      }
    );
  }

  AgregarSubsecretaria(nombre:string)
  {
        this.loadingGeneralSub=true;
        this.dataService.addSubsecretaria(nombre).subscribe(
          data => {
            if (data['objData']) 
            {
              this.notifier.notify(
                'success',
                'Se agrego correctamente.'
              );
              this.nombreSubse="";
              this.cargarSubsecretarias();
              this.loadingGeneralSub=false;
            }
            else{
              this.notifier.notify('error',data['errorMessage']);
            }
          },
          error => {
            console.error(error);
            this.notifier.notify(
              'error',
              'Ha ocurrido un error al intentar agregar la subsecretaria. Verifique su conexión de red o contacte al administrador.'
            );
          }
        );

  }

  eliminarSubsecretaria(id:number)
  {
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id,opcion:18},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneralSub=true;
       this.dataService.deleteSubsecretaria(id).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.cargarSubsecretarias();
             this.loadingGeneralSub=false;

           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar la subsecretaria. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 
       
  }

  modificarSubsecretaria(id:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id,opcion:19,titulo:"Editar subsecretaria",etiqueta:"Subsecretaria"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneralSub=true;
       this.dataService.updateSubsecretaria(id,result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.cargarSubsecretarias();
             this.loadingGeneralSub=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar la subsecretaria. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });  
       
  }

  //------------Direcciones gral-----------------------

  //Filtro para las subsecretarias
  applyFilterDirGral(filterValue: string) {
    this.dataSourceDG.filter = filterValue.trim().toLowerCase();
  }
  
  //Método para cargar las subsecretarias
  cargarDireccionGral()
  {
    this.dataService.getListDireccionesGral().subscribe(
      data => {
        this.listaDirGral = data['data'];
        this.dataSourceDG.data = this.listaDirGral;
        this.dataSourceDG.paginator=this.paginatorDG;
       // this.dataSourceDG.setAttribute("paginatorDG",this.dataSourceDG.paginator);
         //this.dataSourceDG.paginator = this.paginatorDG;
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para cargar la direccion gral. sin subsecretarias
  cargarDireccionGralSinSub()
  {
    this.dataService.getListDireccionesGralSinSub().subscribe(
      data => {
        this.listaDirGralSinSub = data['data'];
        //this.dataSourceDGS.data=this.listaDirGralSinSub;
      },
      error => {
        console.error(error);       
      }
    );
  }


  //Método para editar la direccion gral.
  modificarDirGral(id:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id,opcion:20,titulo:"Editar dirección Gral.",etiqueta:"Dirección General"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneralDirGral=true;
       this.dataService.updateDireccionGral(id,result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.cargarDireccionGral();
             this.loadingGeneralDirGral=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar la dirección gral. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });  
       
  }

  eliminarDirGral(id:number)
  {
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id,opcion:21},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneralDirGral=true;
       this.dataService.deleteDirGral(id).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.cargarDireccionGral();
             this.loadingGeneralDirGral=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar la dirección gral. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 
       
  }


  //Método para agregar direcciones generales
  AgregarDirGral(nombre:string){
    this.loadingGeneralDirGral=true;
        this.dataService.addDireccionGral(nombre).subscribe(
          data => {
            if (data['objData']) 
            {
              this.notifier.notify(
                'success',
                'Se agrego correctamente.'
              );
              this.nombreDirGral="";
              this.cargarDireccionGral();
              this.loadingGeneralDirGral=false;
            }
            else{
              this.notifier.notify('error',data['errorMessage']);
            }
          },
          error => {
            console.error(error);
            this.notifier.notify(
              'error',
              'Ha ocurrido un error al intentar agregar la dirección gral. Verifique su conexión de red o contacte al administrador.'
            );
          }
        );


  }

  //-------Dirección de área-------------------

  //Filtro para la direccion de area
  applyFilterDirArea(filterValue: string) {
    this.dataSourceDA.filter = filterValue.trim().toLowerCase();
  }

  //Método para cargar las direcciones de área
  cargarDireccionArea()
  {
    this.dataService.getListDireccionesArea().subscribe(
      data => {
        this.listaDirArea = data['data'];
        this.dataSourceDA.data =this.listaDirArea;
        this.dataSourceDA.paginator=this.paginatorDA;

      },
      error => {
        console.error(error);       
      }
    );
  }
  

//Método para modificar la dirección de area
  modificarDirArea(id:number)
  {
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id,opcion:22,titulo:"Editar Dirección de área",etiqueta:"Dirección de área"},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneralDirArea=true;
       this.dataService.updateDireccionArea(id,result).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se edito correctamente.'
             );
             this.cargarDireccionArea();
             this.loadingGeneralDirArea=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar editar la dirección de área. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  });  
       
  }

  
  eliminarDirArea(id:number)
  {
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{id:id,opcion:21},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneralDirArea=true;
       this.dataService.deleteDirArea(id).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se elimino correctamente.'
             );
             this.cargarDireccionArea();
             this.loadingGeneralDirArea=false;
           }
           else{
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar eliminar la dirección de área. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 
       
  }


  //Método para agregar direccion de area
  AgregarDirArea(nombre:string){
    this.loadingGeneralDirArea=true;
        this.dataService.addDireccionArea(nombre).subscribe(
          data => {
            if (data['objData']) 
            {
              this.notifier.notify(
                'success',
                'Se agrego correctamente.'
              );
              this.nombreDirArea="";
              this.cargarDireccionArea();
              this.loadingGeneralDirArea=false;
            }
            else{
              this.notifier.notify('error',data['errorMessage']);
            }
          },
          error => {
            console.error(error);
            this.notifier.notify(
              'error',
              'Ha ocurrido un error al intentar agregar la dirección de area. Verifique su conexión de red o contacte al administrador.'
            );
          }
        );


  }

}
